<template>
  <ul class="sidebar-menu">
    <router-link tag="li" class="pageLink" to="/admin/overview">
      <a>
        <i class="fa fa-tachometer"></i>
        <span class="page">Overview</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/users">
      <a>
        <i class="fa fa-users"></i>
        <span class="page">User List</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/videos">
      <a>
        <i class="fa fa-film"></i>
        <span class="page">Videos</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/documents">
      <a>
        <i class="fa fa-file-text"></i>
        <span class="page">Documents</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/categories">
      <a>
        <i class="fa fa-list-alt"></i>
        <span class="page">Categories</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/industries">
      <a>
        <i class="fa fa-industry"></i>
        <span class="page">Industry</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/products">
      <a>
        <i class="fa fa-list"></i>
        <span class="page">Products</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/organisations">
      <a>
        <i class="fa fa-sitemap"></i>
        <span class="page">Organisations</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/admin/product-request">
      <a>
        <i class="fa fa-briefcase"></i>
        <span class="page">Product Requests</span>
      </a>
    </router-link>
    
    <li class="treeview">
      <a href="#" class="clor-w">
        <i class="fa fa-table"></i>
        <span class="treeview-title">Product Catalog</span>
        <span class="pull-right-container pull-right">
          <i class="fa fa-angle-right fa-fw"></i>
        </span>
      </a>
      <ul class="treeview-menu">
         <router-link tag="li" class="pageLink" to="/admin/product-catalog-product">
          <a>
            <i class="fa fa-book"></i>
            <span class="page">Product per Product Catalog</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/product-catalog-category">
          <a>
            <i class="fa fa-book"></i>
            <span class="page">Category per Product Catalog</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/product-type">
          <a>
            <i class="fa fa-book"></i>
            <span class="page">Product Type</span>
          </a>
        </router-link>
         <router-link tag="li" class="pageLink" to="/admin/distributors">
          <a>
            <i class="fa fa-book"></i>
            <span class="page">Distributors</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/product-colours">
          <a>
            <i class="fa fa-book"></i>
            <span class="page">Product Colours</span>
          </a>
        </router-link>
      </ul>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'SidebarMenu'
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
  color: #b8c7ce !important;
}

.sidebar-menu li.active > a > .fa-angle-right,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-right {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?07657412